import { CSSProperties } from 'react';

const containerStyle = (bypassTruncate?: boolean): CSSProperties => ({
    width: '100%',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: bypassTruncate ? 'initial' : 'hidden',
});

interface EllipsisTextComponentProps {
    text: string;
    bypassTruncate?: boolean;
}

export const EllipsisTextView = ({ text = '', bypassTruncate }: EllipsisTextComponentProps) => {
    return (
        <div style={containerStyle(bypassTruncate)} title={text}>
            {text}
        </div>
    );
};
